export default __webpack_public_path__ + "static/media/rohan.3ae805a3.jpg";